// extracted by mini-css-extract-plugin
export default {"header":"SuppliersTable_header__Jhz0I","admin":"SuppliersTable_admin__Ji64O"};